import React, { useEffect, useState } from "react";
import Button from "../../Component/Button/Button";
import {
  getwaitingOrdersApi,
  sendWatingToIdPayPostApi,
} from "../../Api/BarestServices";
import { separate } from "../../Seprate/Seprate";
import Style from "./WaitingForPay.module.css";
import Timer from "../../Component/Timer/Timer";
import { PointSpreadLoading } from "react-loadingg";
import BurgerMenuTitle from "../../Component/BurgerMenuTitle/BurgerMenuTitle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStore } from "@fortawesome/free-solid-svg-icons";
import { ArrowLeftShort } from "react-bootstrap-icons";
import { errorToast } from "../../Toast/Toast";
import { Modal } from "antd";
import OrderPerviewList from "../../Component/OrderPerviewList/OrderPerviewList";
const WaitingForPay = () => {
  const [data, setData] = useState([]);
  const [, setLoad] = useState(false);
  const [disable, setDisable] = useState(false);
  const [modalState, setModalState] = useState(false);
  const [orderDataState, setOrderDataState] = useState([]);
  useEffect(() => {
    getWaitingOrders();
  }, []);
  const getWaitingOrders = async () => {
    getwaitingOrdersApi((succ, res) => {
      if (succ) {
        if (res.status === 0) {
          errorToast("مشکلی پیش آمده است");
        } else {
          setData(res);
        }
      } else {
        console.error(res);
      }
    });
  };
  //////link to idPay ///////////
  const sendToIdPay = (id) => {
    setDisable(true);
    setLoad(true);
    let info = {
      order_id: id,
    };
    sendWatingToIdPayPostApi(info, (res) => {
      setDisable(false);
      window.open(res.link, "_self");
      setLoad(false);
    });
  };
  let loadingItem = null;
  if (data.orders === undefined && data.pay_more === undefined) {
    loadingItem = (
      <div className={Style.loading}>
        <PointSpreadLoading color={"#ab0c59"} size={"small"} />
      </div>
    );
  } else if (data && data.orders.length === 0) {
    loadingItem = (
      <div className={Style.NotOrderFoundHolder}>
        <div className={Style.ImageBasket}>
          <img src="/Assets/Images/Order/not2.png" alt="برست" />
        </div>
      </div>
    );
  } else {
    loadingItem = (
      <>
        <Modal
          title="لیست سفارشات"
          open={modalState}
          onCancel={() => setModalState(false)}
          destroyOnClose
          style={{ direction: "rtl" }}
          closeIcon={<></>}
          footer={null}
        >
          <OrderPerviewList data={orderDataState}/>
        </Modal>
        {data.orders.map((item, index) => {
          return (
            <div key={index} className={Style.orders}>
              {item.carts.map((value, index) => {
                return (
                  <div key={index} className={Style.carts}>
                    <div className={Style.RightOfCart}>
                      <div className={Style.logoHolder}>
                        <img
                          src={`//cdn.barest.ir/supplier/logo/${value.logo}.jpg`}
                          alt="رستوران"
                        />
                      </div>
                      <div className={Style.supplierInfo}>
                        <h3 className={Style.name}>{value.name}</h3>
                        <p className={Style.address}>{value.address}</p>
                      </div>
                    </div>
                    <div
                      className={Style.LeftOfCart}
                      onClick={() => {
                        setModalState(true)
                        setOrderDataState(value.products)
                      }}
                    >
                      <p>سفارشات</p>
                    </div>
                  </div>
                );
              })}
              <section
                style={{
                  direction: "rtl",
                  width: "100%",
                  padding: "1rem",
                  boxSizing: "border-box",
                }}
              >
                <div className={Style.deliverHolder}>
                  شماره سفارش:
                  <span className={Style.spanBuy}>{item.id}</span>
                </div>
                <div className={Style.deliverHolder}>
                  هزینه پیک:
                  <span className={Style.spanBuy}>
                    {separate(item.delivery_price)} تومان{" "}
                  </span>
                </div>
                <div className={Style.deliverHolder}>
                  قیمت محصولات:
                  <span className={Style.spanBuy}>
                    {separate(item.total)} تومان{" "}
                  </span>
                </div>
                {item.discount_code !== "" ? (
                  <div className={Style.deliverHolder}>
                    کد تخفیف استفاده شده:
                    <span className={Style.spanBuy}>{item.discount_code}</span>
                  </div>
                ) : null}
                {item.discount_amount !== "0" ? (
                  <div className={Style.deliverHolder}>
                    تخفیف شما:
                    <span className={Style.spanBuy}>
                      {separate(item.discount_amount)} تومان{" "}
                    </span>
                  </div>
                ) : null}
                <div className={Style.deliverHolder}>
                  هزینه نهایی:
                  <span className={Style.spanBuy}>
                    {separate(
                      parseInt(
                        item.total
                      ) + parseInt(item.delivery_price)-parseInt(item.discount_amount)
                    )}{" "}
                    تومان{" "}
                  </span>
                </div>
              </section>
              <div className={Style.bottomPart}>
                <Button
                  ClassBtn={"confrimBtn"}
                  Value={"پرداخت"}
                  ClickHandler={() => sendToIdPay(item.id)}
                  disabledprops={disable}
                />
                <Timer Time={item.remaining_time} />
              </div>
            </div>
          );
        })}
        {data.pay_more.map((item, index) => {
          return (
            <div key={index} className={Style.orders}>
              <h2 className={Style.editedBySupplier}>
                اصلاحیه توسط تامین کننده
              </h2>
              {item.carts.map((value) => {
                return (
                  <div className={Style.carts}>
                    <div className={Style.logoHolder}>
                      <img
                        src={`//cdn.barest.ir/supplier/logo/${value.logo}.jpg`}
                        alt="رستوران"
                      />
                    </div>
                    <div className={Style.supplierInfo}>
                      <h3 className={Style.name}>
                        <FontAwesomeIcon
                          icon={faStore}
                          className={Style.storeIcon}
                        />
                        {value.name}
                      </h3>
                      <p className={Style.address}>{value.address}</p>
                      {value.products.map((product, index) => {
                        return (
                          <div key={index} className={Style.productsHolder}>
                            <h2 className={Style.productName}>
                              <span
                                style={{
                                  fontSize: ".8rem",
                                  color: "#c20c64",
                                }}
                              >
                                +
                              </span>
                              {product.name}
                            </h2>
                            <div className={Style.changes}>
                              <div className={Style.prices}>
                                <h2 className={Style.oldPrice}>
                                  {product.price}
                                </h2>
                                <ArrowLeftShort style={{ fontSize: "1rem" }} />
                                <h2 className={Style.newPrice}>
                                  {product.new_price}تومان
                                </h2>
                              </div>
                              <div className={Style.prices}>
                                <h2 className={Style.oldPrice}>
                                  {product.count}
                                </h2>
                                <ArrowLeftShort style={{ fontSize: "1rem" }} />
                                <h2 className={Style.newPrice}>
                                  {product.new_count}
                                </h2>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                      <div className={Style.deliverHolder}>
                        هزینه پرداختی:
                        <span className={Style.spanBuy}>
                          {separate(item.total)} تومان{" "}
                        </span>
                      </div>
                    </div>
                  </div>
                );
              })}
              <div className={Style.bottomPart}>
                {/* <Button
                ClassBtn={"confrimBtn"}
                Value={"پرداخت"}
                disabledprops={disable}
                ClickHandler={() => sendToIdPay(item.id)}
              /> */}
              </div>
            </div>
          );
        })}
      </>
    );
  }
  return (
    <div className={Style.componentHolder}>
      <BurgerMenuTitle title={"سبد خرید"} />
      {loadingItem}
    </div>
  );
};
export default WaitingForPay;
